import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SiteLayout } from "@/components/site/SiteLayout";

import Home from "@/pages/Home";
import Systems from "@/pages/Systems";
import SystemDetail from "@/pages/SystemDetail";
import Technology from "@/pages/Technology";
import Company from "@/pages/Company";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminProducts from "@/admin/AdminProducts";
import AdminInsights from "@/admin/AdminInsights";
import AdminCareers from "@/admin/AdminCareers";
import AdminApplications from "@/admin/AdminApplications";
import AdminEnquiries from "@/admin/AdminEnquiries";
import AdminSettings from "@/admin/AdminSettings";
import AuthCallback from "@/admin/AuthCallback";

import { CommandProvider } from "@/context/CommandContext";
import CommandLogin from "@/command/CommandLogin";
import CommandLayout from "@/command/CommandLayout";

function AppRouter() {
  const location = useLocation();
  // Process Emergent OAuth return before anything else (synchronous check).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/systems" element={<Systems />} />
        <Route path="/systems/:slug" element={<SystemDetail />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/company" element={<Company />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="insights" element={<AdminInsights />} />
        <Route path="careers" element={<AdminCareers />} />
        <Route path="applications" element={<AdminApplications />} />
        <Route path="enquiries" element={<AdminEnquiries />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>

      <Route path="/command/login" element={<CommandLogin />} />
      <Route path="/command/*" element={<CommandProvider><CommandLayout /></CommandProvider>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
